import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(id, title) {
  return {
    title: `${title} の動画配信なら SPOOX(スプークス)`,
    keywords: `${title},SPOOX,スプークス,動画配信,スカパー！`,
    description: `${title}をピックアップ！SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.palette(id)}`,
    },
  };
}

export default function PaletteMetaTags({ id, title }) {
  const props = tags(id, title);

  return <MetaTags {...props} />;
}
